import React from 'react';
import '../styles/not-found.css';
import { useNavigate } from 'react-router-dom';
import errorImg from "../assets/imgs/colivri-404-page.png";
import { useTranslation } from 'react-i18next';

const Error = () => {
  const { t } = useTranslation('errors');

  const navigate = useNavigate();
  return (
    <div className="error-container">
      <div className="error-content">
        <img src={errorImg} alt="error404Image"></img>
        <div className="error-text">
          <button className="back-button" onClick={() => navigate('/')} >{t('go-back')}</button>
        </div>
      </div>
    </div>
  );
};

export default Error;
